import theme from '~lib/styles/Theme';
import { ICompanyWorkLife, IWorkLifeObj } from '~types/company';
import { getPercentage } from '~utils/formatted/string';

interface UseChartProps {
  chartData?: IWorkLifeObj[];
}

export function useChartProps({ chartData }: UseChartProps) {
  if (!chartData) {
    return {};
  }

  const maxCount = Math.max(...chartData.map((obj) => obj.count));
  const maxYAxis = maxCount * 1.5;

  const data = {
    labels: ['거의 없음', '주 1-2회', '주 3-4회', '주 5회 이상'],
    datasets: [
      {
        type: 'bar',
        data: chartData,
        backgroundColor: theme.colors.magenta500,
        hoverBackgroundColor: theme.colors.magenta500,
        borderWidth: 0,
        barThickness: 30,
        borderRadius: 2,
        parsing: {
          xAxisKey: 'count',
          yAxisKey: 'count',
        },
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            weight: '500',
            lineHeight: '12px',
            size: '10px',
            family: 'Pretendard',
          },
          color: theme.colors.gray700,
        },
      },
      y: {
        max: maxYAxis,
        grid: {
          drawBorder: false,
          display: false,
        },
        ticks: {
          display: false,
        },
      },
    },
    borderWidth: 1,
    plugins: {
      tooltip: {
        enabled: false,
      },
      legend: {
        display: false,
      },
      datalabels: {
        labels: {
          value: {
            color: theme.colors.gray800,
            align: 'end',
            anchor: 'end',
            font: {
              weight: '500',
              size: '10px',
              family: 'Pretendard',
            },
            formatter: (barInfo: any) => {
              if (chartData.every((obj) => obj.count === 0)) {
                return null;
              }

              if (!barInfo?.count) {
                return '00(00%)';
              }

              return `${barInfo.count} (${getPercentage(barInfo.rate)}%)`;
            },
          },
        },
      },
    },
  };

  return { data, options };
}
